import React from "react";
import HorizontalRule from "../../Rule/Horizontal";

type Props = { subtitle?: string; children?: React.ReactNode };

export default function CenterHeader({ children, subtitle }: Props) {
  return (
    <div className="max-h-[210px]">
      <div className="flex flex-col gap-2.5">
        {subtitle && (
          <div className="text-base text-neutral-400">{subtitle}</div>
        )}
        <div className="text-[38px] font-light leading-[48px] tracking[-1.52px]">
          {children}
        </div>
      </div>
      <HorizontalRule
        thickness={1}
        className="bg-brand-neutral-05"
        margin="2.5rem 0"
      />
    </div>
  );
}
